module.exports = __webpack_public_path__ + "static/media/CT_2019_30447_W6053.3d189352.png";